<template>
  <section class="section">

    <button @click="excelDatos" v-if="tokenUser !== null ? tokenUser.admin : false"
            class="button is-link is-large btn-print"
            v-tooltip.left="'Datos Sin agrupar'"
            style="background-color: #2DC84E !important; box-shadow: none"><span class="icon"><i
        class="material-icons">folder_copy</i></span></button>

    <button @click="imprimir" class="button is-link is-large btn-print"
            v-tooltip.left="'PDF Informe'"
            style="margin-top: 70px; box-shadow: none"><span
        class="icon"><i
        class="material-icons">picture_as_pdf</i></span></button>

    <button @click="datos" class="button is-link is-large btn-print"
            v-tooltip.left="'Datos Agrupados'"
            style="margin-top: 140px;  background-color: #2DC84E !important; box-shadow: none"><span class="icon"><i
        class="material-icons">library_books</i></span></button>

    <div class="container">
      <div v-for="(item, index) in vista" :key="index">
        <div v-if="!item.isgraficador" class="columns">
          <div class="column" v-if="item.tColumna1" :class="color(item.tColumna1)">
            <div v-for="(subitem, subindex) in item.columna1" :key="subindex">
              <y-subitem :subitem="subitem" :columna="1" :iditem="item.id"></y-subitem>
            </div>
          </div>
          <div class="column" v-if="item.tColumna2" :class="color(item.tColumna2)">
            <div v-for="(subitem, subindex) in item.columna2" :key="subindex">
              <y-subitem :subitem="subitem" :columna="2" :iditem="item.id"></y-subitem>
            </div>
          </div>
          <div class="column" v-if="item.tColumna3" :class="color(item.tColumna3)">
            <div v-for="(subitem, subindex) in item.columna3" :key="subindex">
              <y-subitem :subitem="subitem" :columna="3" :iditem="item.id"></y-subitem>
            </div>
          </div>
        </div>
        <div v-if="item.isgraficador">
          <y-graphiccreatorfrs :idfrs="idfrs"></y-graphiccreatorfrs>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapState} from "vuex";
import ySubitem from "@/components/informes/Subitem.vue";
import yGraphiccreatorfrs from "@/components/informes/Graphiccreatorfrs.vue"
import apiServices from "@/services/yungol-services";

const XLSX = require("xlsx");


export default {
  data() {
    return {
      variables: [],
    }
  },
  props: {
    vista: {
      type: Array
    },
    idfrs: {
      type: String
    }
  },
  computed: {
    ...mapState(["tokenUser"]),
  },
  methods: {
    color(c) {
      const size = {
        "col-md-12": "is-12",
        "col-md-4": "is-4",
        "col-md-7": "is-7",
        "col-md-5": "is-5",
        "col-md-6": "is-6"
      };
      return size[c];
    },
    imprimir() {
      window.print()
    },
    widthCols(data) {
      let values = []

      try {
        //  Se recorre todos los datos
        for (let i = 0; i < data.length; i++) {
          let cont = 0;
          // Se recorre la informacion de un Dato
          for (const d in data[i]) {
            // Si es la primera iteracion arma el dato con el tamaño del campo y lo guarda la array values
            if (i === 0) {
              let w = {width: (String(data[i][d]).length + 2)}
              values.push(w)
            }
                //  Si no es la primera iteracion compara los datos nuevo con los valores del array values
            //  con el fin de extraer el numero mas grande
            else {
              let w = (String(data[i][d]).length + 2)
              if (values[cont].width < w) {
                values[cont].width = w;
              }
              cont++;
            }
          }
        }
        // Se valian los tamaños de los titulos para evitar corte de texto en el Excel
        let cont = 0;
        for (const key in data[0]) {
          let w = (String(key).length + 2)
          if (values[cont].width < w) {
            values[cont].width = w;
          }
          cont++;
        }

        //  Se devuelve values con el formato necesario para el tamaño de columnas del Excel
        return values
      } catch (err) {
        console.log(err)
      }
    },
    async excelDatos() {
      try {
        //  Se extra la data de la empresa actual
        const {data} = await apiServices.get(`/find/reports`);

        this.excel(data);

      } catch (error) {
        console.log(error);
      }
    },
    async excel(dato) {
      try {
        let data = dato
        if (data.data.length > 0) {
          //  Recorremos las diferentes datas creando un Excel para cada uno
          for (let i = 0; i < data.data.length; i++) {
            //  Asignamos la informacion necesaria a nuevas variables
            let dataExc = data.data[i];
            let name = data.names[i];

            //  Se agrega la data al libro de excel
            var ws = XLSX.utils.json_to_sheet(dataExc);

            //  Se configura el tamaño de cada columna
            const widths = this.widthCols(dataExc);
            ws["!cols"] = widths

            //  Se crea el libro con la data agregada, se le da un nombre y finalizando se descarga
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Hoja1");
            var nombreArchivo = name + ".xlsx";
            XLSX.writeFile(wb, nombreArchivo);

          }
        } else {
          this.$store.dispatch("notify", {
            message: `No hay datos para descargar`,
            type: "is-link",
          });
        }

      } catch (err) {
        console.log(err);
        this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel`,
          type: "is-danger",
        });
      }
    },
    datos() {
      if (this.tokenUser) {
        this.$router.push('datamenu')
      } else {
        window.location.href = 'https://app.sietegho.com/datamenu';
      }
    }
  },
  components: {
    ySubitem,
    yGraphiccreatorfrs
  }
};
</script>


// WEBPACK FOOTER //
// src/components/informes/Vista.vue